import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { MantineProvider, createTheme } from "@mantine/core";
import "@mantine/core/styles.css";
import "./index.css";

import { store } from "./store/store";
import { initializeAuthHttp } from "./features/auth/authHttp";
import App from "./App";

initializeAuthHttp(store);

const theme = createTheme({
  primaryColor: "blue", 
  black: "#222222", 
  fontFamily: "Inter, system-ui, Avenir, Helvetica, Arial, sans-serif",
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <MantineProvider theme={theme}>
          <App />
        </MantineProvider>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>,
);
